/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";

  var scanqr = function scanqr() {
    cordova.plugins.barcodeScanner.scan(function (result) {
      $("#winning_orderID").val(result.text);
      search();
    }, function (error) {
      alert("Scanning failed: " + error);
    });
  };

  var searchButton = function searchButton() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'winning.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderID: $("#winning_orderID").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          console.log("receipt length" + data.strikes.length);
          receipt = "";

          for (var i = 0; i < data.strikes.length; i++) {
            var dtype = "";
            var rdate = data.strikes[i].drawDate.split("-").reverse().join("-");
            ;
            if (data.strikes[i].drawType == "8") dtype = "<img src='static/images/gd.png' style='width:30px;' class='vmiddle'> GD Lottery";
            if (data.strikes[i].drawType == "4") dtype = "<img src='static/images/sg.png' style='width:30px;' class='vmiddle'> SG Lotto";
            receipt += "\n            <div class=\"card\">\n              <div class=\"card-header\" style=\"background-color:var(--f7-theme-color); height:30px\">\n                <table width=100%>\n                  <td style=\"text-align:left\"><h3>" + dtype + "</h3></td>\n                  <td style=\"text-align:right\"><h3>" + rdate + "</h3></td>\n                </table> \n              </div>\n              <div class=\"card-content card-content-padding\">\n                \n                <table width=100%>\n                  <thead>\n                    <tr>\n                      <th>\n                        <span class='en'>Prize</span>\n                        <span class='cn'>\u5956</span>\n                        <span class='tl'>Presu</span>\n                      </th>\n                      <th>iBox</th>\n                      <th>\n                        <span class='en'>Number</span>\n                        <span class='cn'>\u53F7\u7801</span>\n                        <span class='tl'>Numeru</span>\n                      </th>\n                      <th>\n                        <span class='en'>Bet</span>\n                        <span class='cn'>\u8D4C\u6CE8</span>\n                        <span class='tl'>Joga</span>\n                      </th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr>\n                      <td style=\"text-align:center\">" + data.strikes[i].prize + "</td>\n                      <td style=\"text-align:center\">" + data.strikes[i].ibox + "</td>\n                      <td style=\"text-align:center\">" + data.strikes[i].betPosition + "" + data.strikes[i].number + "</td>\n                      <td style=\"text-align:center\">" + data.strikes[i].bet + "</td>\n                    </tr> \n                  </tbody> \n                </table>\n                </div>\n              <div class=\"card-footer\">\n                <table width=100%>\n                  <td style=\"text-align:left\">\n                    <span class='en'>Winning Prize</span>\n                    <span class='cn'>\u83B7\u5956</span>\n                    <span class='tl'>/ Presu Manan</span>\n                  </td>\n                  <td style=\"text-align:right\"><h2>USD " + data.strikes[i].winning + "</h2></td>\n                </table> \n              </div>\n              \n            </div>\n\n            ";
          }

          $update();
        } else {
          $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  var search = function search() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'winning.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        drawDateFrom: $("#drawDateFrom").val(),
        drawDateTo: $("#drawDateTo").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          console.log("receipt length" + data.strikes.length);
          receipt = "";

          for (var i = 0; i < data.strikes.length; i++) {
            var dtype = "";
            var rdate = data.strikes[i].drawDate.split("-").reverse().join("-");
            ;
            if (data.strikes[i].drawType == "8") dtype = "<img src='static/images/gd.png' style='width:30px;' class='vmiddle'> GD Lottery";
            if (data.strikes[i].drawType == "4") dtype = "<img src='static/images/sg.png' style='width:30px;' class='vmiddle'> SG Lotto";
            receipt += "\n              <div class=\"card\">\n                <div class=\"card-header\" style=\"background-color:var(--f7-theme-color); height:30px\">\n                  <table width=100%>\n                    <td style=\"text-align:left\"><h3>" + dtype + "</h3></td>\n                    <td style=\"text-align:right\"><h3>" + rdate + "</h3></td>\n                  </table> \n                </div>\n                <div class=\"card-content card-content-padding\">\n                  \n                  <table width=100%>\n                    <thead>\n                      <tr>\n                        <th>Prize</th>\n                        <th>iBox</th>\n                        <th>Number</th>\n                        <th>Bet</th>\n                      </tr>\n                    </thead>\n                    <tbody>\n                      <tr>\n                        <td style=\"text-align:center\">" + data.strikes[i].prize + "</td>\n                        <td style=\"text-align:center\">" + data.strikes[i].ibox + "</td>\n                        <td style=\"text-align:center\">" + data.strikes[i].betPosition + "" + data.strikes[i].number + "</td>\n                        <td style=\"text-align:center\">" + data.strikes[i].bet + "</td>\n                      </tr> \n                    </tbody> \n                  </table>\n                  </div>\n                <div class=\"card-footer\">\n                  <table width=100%>\n                    <td style=\"text-align:left\">\n                    <span class='en'>Winning Prize</span>\n                    <span class='cn'>\u83B7\u5956</span>\n                    <span class='tl'>Presu Manan</span>\n                  </td>\n                    <td style=\"text-align:right\"><h2>USD " + data.strikes[i].winning + "</h2></td>\n                  </table> \n                </div>\n                \n              </div>\n\n              ";
          }

          $update();
        } else {
          $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  $on('pageAfterOut', function () {
    clearInterval(window.langPlace6);
  });
  $on('pageInit', function () {
    window.langPlace6 = setInterval(function () {
      if (window.lang == "tl") document.getElementById("winning_orderID").placeholder = "Scan ka tama hameno id";
      if (window.lang == "en") document.getElementById("winning_orderID").placeholder = "Scan or enter your order id";
      if (window.lang == "cn") document.getElementById("winning_orderID").placeholder = "扫描或输入您的订单编号";
    }, 100);
    document.getElementById('drawDateFrom').valueAsDate = new Date();
    document.getElementById('drawDateTo').valueAsDate = new Date();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
            <span class='en'>Back</span>
            <span class='cn'>返回</span>
            <span class='tl'>Fila</span>
          </span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Winning</span>
        <span class='cn'>中奖</span>
        <span class='tl'>Manan Nain</span>
      </div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">
      <span class='en'>Winning List</span>
      <span class='cn'>中奖名单</span>
      <span class='tl'>Lista manan nain</span>
    </div>


    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Order ID</span>
              <span class='cn'>订单编号</span>
              <span class='tl'>Hameno ID</span>
            </div>
            <div class="item-input-wrap">
              <input type="text"  placeholder="Scan or Enter your order id" id="winning_orderID"/>
            </div>
          </div>
        </li>
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button button-fill color-theme-orange button-scan" @click="${scanqr}">
              <span class='en'>Scan</span>
              <span class='cn'>扫描</span>
              <span class='tl'>Scan</span>
            </button>
            <button class="button button-fill" @click="${searchButton}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>

    <div class="block-title">
      <span class='en'>Draw Date</span>
      <span class='cn'>抽奖日期</span>
      <span class='tl'>Data soe </span>
    </div>
    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>From</span>
              <span class='cn'>开始</span>
              <span class='tl'>Husi</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="drawDateFrom"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>To</span>
              <span class='cn'>结束</span>
              <span class='tl'>Ba</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="drawDateTo"/>
            </div>
          </div>
        </li>   
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
        
      </ul>
    </div>
    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div innerHTML=${receipt}>

    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'ecc4a9ad29';
export default framework7Component;